export default "__VITE_ASSET__BY2Sigpe__"